import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

const HeroSection = () => {
    return (
        <section
            id="home"
            className="bg-gray-900 text-white h-screen flex flex-col justify-center items-center text-center relative"
        >
            {/* HeroSection Content */}
            <div className="max-w-4xl mx-auto px-6">
                <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-fade-in">
                    Hi, I'm <span className="text-teal-400">Bheesham Kumar</span>
                </h1>
                <p className="text-lg md:text-xl text-gray-400 mb-6 animate-fade-in">
                    A passionate <span className="text-teal-400">Web Developer</span> crafting beautiful & functional websites.
                </p>
                <div className="space-x-4 animate-fade-in">
                    <a
                        href="#projects"
                        className="bg-teal-400 text-gray-900 py-3 px-6 rounded-lg text-lg font-semibold shadow-lg hover:bg-teal-300 transition duration-300"
                    >
                        View My Work
                    </a>
                    <a
                        href="#contact"
                        className="border border-teal-400 text-teal-400 py-3 px-6 rounded-lg text-lg font-semibold hover:bg-teal-400 hover:text-gray-900 transition duration-300"
                    >
                        Contact Me
                    </a>
                </div>
            </div>

            {/* Down Arrow */}
            <div className="absolute bottom-6 animate-bounce">
                <a href="#about" className="text-teal-400 text-3xl">
                    <FontAwesomeIcon icon={faArrowDown} />
                </a>
            </div>
        </section>
    );
};

export default HeroSection;
